import http from '@/utils/http';

export default {
	save: data => {
		return http({ url: '/api/admin/v1/dept/save', data, tip: true }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/dept/delete', data, tip: true }).then(r => r);
	},
	listAll: data => {
		return http({ url: '/api/admin/v1/dept/listAll', data }).then(r => r);
	},
	operationCenterList: data => {
		return http({ url: '/api/admin/v1/dept/operationCenterList', data }).then(r => r);
	},
};
